export const videos = {
    "onboardingShort": "https://willowdocs.s3.amazonaws.com/Willow+Welcome+Video.mp4",
    "onboardingLong": "https://willowdocs.s3.amazonaws.com/Willow+Consumer+Demo.mp4",
}
